import React, { useState } from 'react';
import { Sun, Cloud, CloudRain, CloudLightning, Snowflake } from 'lucide-react';

export interface WeatherWidgetProps {
  temperature?: number;
  condition?: 'Sunny' | 'Cloudy' | 'Rainy' | 'Stormy' | 'Snowy';
  location?: string;
  className?: string;
}

const weatherIcons = {
  Sunny: Sun,
  Cloudy: Cloud,
  Rainy: CloudRain,
  Stormy: CloudLightning,
  Snowy: Snowflake,
};

export const WeatherWidget: React.FC<WeatherWidgetProps> = ({
  temperature = 24,
  condition = 'Sunny',
  location = 'Udaipur',
  className = '',
}) => {
  const [isCelsius, setIsCelsius] = useState(true);

  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  const WeatherIcon = weatherIcons[condition] || Sun;

  const displayTemp = isCelsius ? temperature : Math.round((temperature * 9/5) + 32);
  const tempUnit = isCelsius ? 'C' : 'F';

  const toggleUnit = () => setIsCelsius(!isCelsius);

  return (
    <div
      className={`
        bg-[rgba(212,160,84,0.85)] backdrop-blur-md rounded-2xl px-5 py-4 text-white
        flex items-center gap-4 min-w-[200px]
        ${className}
      `}
    >
      {/* Left Side - Temperature & Info */}
      <div className="flex-1">
        <div className="flex items-baseline gap-1">
          <span className="text-[32px] font-bold leading-none">
            {displayTemp}°
          </span>
          <button
            onClick={toggleUnit}
            className="text-sm font-medium bg-white/20 hover:bg-white/30 px-2 py-0.5 rounded transition-colors"
          >
            {tempUnit}
          </button>
        </div>
        
        <div className="text-xs uppercase tracking-wider opacity-90 mb-0.5 mt-1">
          {location}
        </div>
        <div className="text-sm opacity-90">
          {today}
        </div>
      </div>

      {/* Right Side - Icon */}
      <div className="flex flex-col items-center">
        <WeatherIcon className="w-12 h-12" strokeWidth={1.5} />
        <span className="text-xs mt-1 opacity-90">{condition}</span>
      </div>
    </div>
  );
};

export default WeatherWidget;
